// eslint-disable-next-line sonarjs/slow-regex -- Disabled for plugin version update. Fix when possible.
const HTML_CONTENT_REGEX = /^```html\s*([\s\S]*?)\s*```$/gm;

export const isHtmlContent = (text: string): boolean =>
  HTML_CONTENT_REGEX.test(text);

export function extractHtmlContent(responseText: string): string {
  // Normalize BR tags: remove invalid closing tags and standardize to <br />
  return (
    responseText
      .replace(HTML_CONTENT_REGEX, "$1")
      .trim()
      .replace(/<\/?\s*br\s*>/gi, match =>
        match.startsWith("</") ? "" : "<br />",
      )
      // eslint-disable-next-line sonarjs/slow-regex -- Disabled for plugin version update. Fix when possible.
      .replace(/<\s*br\s*\/?\s*>/gi, "<br />")
  );
}

export const wrapAsHtmlFence = (html: string): string =>
  `\`\`\`html\n${html}\n\`\`\``;

export const isElement = (node: ChildNode): node is Element =>
  node.nodeType === Node.ELEMENT_NODE;

// Tokenize HTML content into an array of tokens
export const tokenizeHtml = (html: string): string[] => {
  const div = document.createElement("div");
  div.innerHTML = html;

  const tokens: string[] = [];
  const walkNodes = (node: ChildNode) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const words = (node.textContent || "").match(/\S+\s*/g) || [];
      tokens.push(...words);
    } else if (isElement(node)) {
      // eslint-disable-next-line sonarjs/prefer-regexp-exec -- Disabled for plugin version update. Fix when possible.
      tokens.push(node.outerHTML.match(/^<[^>]+>/)?.[0] || "");

      node.childNodes.forEach(walkNodes);

      const tagName = node.tagName.toLowerCase();
      tokens.push(`</${tagName}>`);
    }
  };

  div.childNodes.forEach(walkNodes);
  return tokens;
};
